import { PostHogProvider } from '@posthog/react';
import type { ReactNode } from 'react';
import { posthog } from './analytics';

/**
 * Wraps the partner app with PostHog's React provider so any
 * component can call `usePostHog()` from '@posthog/react'.
 */
export function AnalyticsProvider({ children }: { children: ReactNode }) {
  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
}
